import { BaseClient } from './BaseClient'

export class AuthApi extends BaseClient {
  token = {
    getByLogin: this.createRequest({
      url: '/api/login',
      method: 'post',
    }),

    getByHash: this.createRequest({
      url: '/api/login_legacy',
      method: 'post',
    }),

    getByRegister: this.createRequest({
      url: '/api/register',
      method: 'post',
    }),

    getByTg: this.createRequest({
      url: '/api/login_telegram',
      method: 'post',
    }),
  }
}
